import React, { useState, useEffect } from 'react';
import { PageHeader, Badge } from '../../components/UI';
import { adminApi } from '../../utils/api';
import toast from 'react-hot-toast';

export default function AdminPayments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  const load = async () => {
    setLoading(true);
    try { const { data } = await adminApi.get('/api/admin/payments'); if (data.success) setPayments(data.payments); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    if (!window.confirm('Approve and activate account?')) return;
    const { data } = await adminApi.put(`/api/admin/payments/${id}/approve`, {});
    if (data.success) { toast.success('Payment approved!'); load(); } else toast.error(data.message);
  };

  const reject = async (id) => {
    const reason = window.prompt('Reason for rejection:');
    if (!reason) return;
    const { data } = await adminApi.put(`/api/admin/payments/${id}/reject`, { reason });
    if (data.success) { toast.success('Rejected'); load(); } else toast.error(data.message);
  };

  const filtered = filter ? payments.filter(p => p.status === filter) : payments;

  return (
    <div>
      <PageHeader title="Payment Management" />
      <div style={{ marginBottom: 20 }}>
        <select value={filter} onChange={e => setFilter(e.target.value)} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 8, padding: '9px 14px', color: 'var(--text)', fontSize: 13 }}>
          <option value="">All Payments</option>
          <option value="pending">⏳ Pending</option>
          <option value="approved">✅ Approved</option>
          <option value="rejected">❌ Rejected</option>
        </select>
      </div>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>{['Invoice #', 'Client', 'Plan', 'Amount', 'GST', 'Total', 'Txn ID', 'Date', 'Status', 'Actions'].map(h => <th key={h} style={{ background: 'var(--bg)', padding: '10px 14px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: 0.5, borderBottom: '1px solid var(--border)', whiteSpace: 'nowrap' }}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="10" style={{ textAlign: 'center', padding: 32, color: 'var(--text-muted)' }}>Loading...</td></tr>
              ) : filtered.length === 0 ? (
                <tr><td colSpan="10" style={{ textAlign: 'center', padding: 32, color: 'var(--text-muted)' }}>No payments found</td></tr>
              ) : filtered.map(p => (
                <tr key={p.id} style={{ borderBottom: '1px solid var(--border)' }}>
                  <td style={{ padding: '12px 14px', fontFamily: 'monospace', fontSize: 12, color: 'var(--green)' }}>{p.invoice_number || '—'}</td>
                  <td style={{ padding: '12px 14px' }}><div style={{ fontWeight: 600, fontSize: 13 }}>{p.name}</div><div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{p.email}</div></td>
                  <td style={{ padding: '12px 14px' }}><Badge>{p.plan_name}</Badge></td>
                  <td style={{ padding: '12px 14px', fontSize: 13 }}>{p.currency === 'USD' ? '$' : '₹'}{parseFloat(p.amount || 0).toFixed(2)}</td>
                  <td style={{ padding: '12px 14px', fontSize: 12, color: 'var(--text-muted)' }}>{p.gst_type === 'NONE' ? 'N/A' : p.gst_type}</td>
                  <td style={{ padding: '12px 14px', fontWeight: 700, color: 'var(--green)' }}>{p.currency === 'USD' ? '$' : '₹'}{parseFloat(p.total_amount || 0).toFixed(2)}</td>
                  <td style={{ padding: '12px 14px', fontFamily: 'monospace', fontSize: 11, color: '#4da8ff', maxWidth: 120 }}>{p.transaction_id || '—'}</td>
                  <td style={{ padding: '12px 14px', fontSize: 12, whiteSpace: 'nowrap' }}>{new Date(p.created_at).toLocaleDateString('en-IN')}</td>
                  <td style={{ padding: '12px 14px' }}><Badge>{p.status}</Badge></td>
                  <td style={{ padding: '12px 14px' }}>
                    {p.status === 'pending' && (
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => approve(p.id)} style={{ background: 'rgba(0,231,76,0.1)', color: 'var(--green)', border: 'none', padding: '5px 10px', borderRadius: 6, fontSize: 11, cursor: 'pointer' }}>✅</button>
                        <button onClick={() => reject(p.id)} style={{ background: 'rgba(255,68,68,0.1)', color: '#ff6b6b', border: 'none', padding: '5px 10px', borderRadius: 6, fontSize: 11, cursor: 'pointer' }}>❌</button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}